import(/* webpackMode: "eager" */ "/opt/storelancer/releases/20261014193255-3b00702af6c9/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/opt/storelancer/releases/20261014193255-3b00702af6c9/src/components/dashboard/auth-forms.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UiText","UiNav","StatusText"] */ "/opt/storelancer/releases/20261014193255-3b00702af6c9/src/components/ui/i18n.tsx");
